import { ProgressBarProps } from 'Types/Presentation/Components/ProgressBar'

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
	return (
		<div className="progress bg-kumopack-grey-200 shadow-sm">
			<div
				className="progress-bar bg-kumopack-primary-600"
				role="progressbar"
				aria-label="Basic example"
				style={{ width: `${progress}%` }}
				aria-valuenow={progress}
				aria-valuemin={0}
				aria-valuemax={100}></div>
		</div>
	)
}

export default ProgressBar
